import * as React from 'react';
import { PreChatRoute } from 'components/LazyRoutes';
import { useChatInstance } from './chat-session.provider';

// Mounting pre-chat at the canonical live-chat path is what selects Chat v2.
export const ChatRoute = () => {
  const chatInstance = useChatInstance();

  if (!chatInstance) return null;

  return <PreChatRoute chatInstance={chatInstance} />;
};
